import { toastVariants } from '@/components/Toast/toastVariants';
import { EnumValues } from '@/services/types/EnumValues';
import { VariantProps } from 'class-variance-authority';

export type TNotificationState = {
  type: NotificationType;
  data?: Record<string, string>;
};

export interface TNotification {
  type: NotificationType;
  variant: VariantProps<typeof toastVariants>['variant'];
  title?: string;
  description: string;
}

export const NotificationType = {
  CONNECT_SUCCESS: 'connect_success',
  LOST_CONNECTION: 'lost_connection',
  REAUTHENTICATION_REQUIRED: 'reauthentication_required',
  DISCONNECT_SUCCESS: 'disconnect_success',
  CREATE_BATCH_SUCCESS: 'create_batch_success',
  BATCH_DELETED: 'batch_deleted',
  BATCH_PAYMENT_COMPLETE: 'batch_payment_complete',
  BATCH_PAYMENT_INCOMPLETE: 'batch_payment_incomplete',
  TRANSACTION_GL_CODE_ADD_SUCCESS: 'transaction_gl_code_add_success',
  TRANSACTION_GL_CODE_UPDATE_SUCCESS: 'transaction_gl_code_update_success',
  TRANSACTION_GL_CODE_REMOVE_SUCCESS: 'transaction_gl_code_remove_success',
  GL_CODES_DISABLED: 'gl_codes_disabled',
  GL_CODES_ENABLED: 'gl_codes_enabled',
  GL_CODE_ARCHIVED: 'gl_code_archived',
  GL_CODE_DELETED: 'gl_code_deleted',
  GL_CODE_RESTORED: 'gl_code_restored',
  GL_CODE_UPDATED: 'gl_code_updated',
  GL_CODES_SAVED: 'gl_codes_saved',
  ATTACHMENT_REMOVED: 'attachment_removed',
  ATTACHMENT_ADDED: 'attachment_added',
  ATTACHMENT_UPLOAD_ERROR: 'attachment_upload_error',
  NO_AVAILABLE_XERO_ORGANIZATION: 'no_available_xero_organization',
  PASSKEY_CREATED: 'passkey_created',
  PASSKEY_REMOVED: 'passkey_removed',
  TEAM_MEMBER_CARDS_FROZEN: 'team_member_cards_frozen',
  TEAM_MEMBER_CARDS_UNFROZEN: 'team_member_cards_unfrozen',
  TEAM_MEMBERS_PAUSED: 'team_members_paused',
  TEAM_MEMBERS_ENABLED: 'team_members_enabled',
  TEAM_MEMBERS_REMOVED: 'team_members_removed',
  TEAM_MEMBER_ACCESS_LEVEL_UPDATED: 'team_member_access_level_updated',
  TEAM_MEMBER_CARD_CREATED: 'team_member_card_created',
  TEAM_MEMBER_INVITE_UPDATED: 'team_member_invite_updated',
  TEAM_MEMBER_INVITE_DELETED: 'team_member_invite_deleted',
  TEAM_MEMBER_CARD_DELETED: 'team_member_card_deleted',
  TEAM_MEMBER_CARD_SETTINGS_UPDATED: 'team_member_card_settings_updated',
  UNKNOWN_ERROR: 'unknown_error'
} as const;

export type NotificationType = EnumValues<typeof NotificationType>;
